const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment-timezone');
/**
 * Defines the Date Format component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('dateFormat', ['Authorization', function (Authorization) {
  return {
    restrict: 'E',
    scope: {
      date: '=?',
      format: '=?',
      external: '=?',
      time: '@?'
    },
    replace: true,
    template: require('../../templates/directives/date-format.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.company = Authorization.getAuthToken() && Authorization.getAuthToken().company || {};
      var date_display = self.company.date_display || 'usa';

      if (!$scope.date) {
        self.postFormat = '------';
        return;
      }

      self.finalFormat = '';
      self.styles = {
        "display": "inline"
      };
      self.formatOptions = {
        usa: {
          'base': 'M-DD-YYYY',
          'dateSlash': 'M/DD/YYYY',
          'time': 'h:mmA',
          'long': 'ddd, MMM Do @ h:mmA',
          'formal': 'MMMM Do, YYYY'
        },
        australia: {
          'base': 'DD-M-YYYY',
          'dateSlash': 'DD/M/YYYY',
          'time': 'h:mmA',
          'long': 'ddd, MMM Do @ h:mmA',
          'formal': 'MMMM Do, YYYY'
        }
      };

      self.formats = self.formatOptions[date_display] || self.formatOptions.usa;

      var date = $scope.date ? $scope.date : new Date();
      var format = self.formats.base;

      if ($scope.format && self.formats[$scope.format]) {
        format = self.formats[$scope.format];
      }

      if ($scope.time) {
        format = format + ' ' + self.formats.time;
      }

      self.postFormat = moment(date).format(format);

      if($scope.external){
        self.styles.display = 'none';
        $scope.external = self.postFormat;
      }
    }],
    controllerAs: 'formatter'
  };
}]);